<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="d-flex align-items-center my-1 mx-2">
      <h2 class="me-4">All Polls</h2>
      <router-link to="/poll/add">
        <button v-if="permissions.ADD_CONTENT === 'Y'" class="btn btn-sm border border-primary text-primary">
          Add New Poll
        </button>
      </router-link>
    </div>
    <div v-if="loading" class="text-center">
      <div class="text-center mb-3 justify-content-between">
        <b-spinner variant="primary"></b-spinner>
      </div>
    </div>
    <div v-else class="d-flex flex-column mx-2 mb-5">
      <!--      <h1 class="mb-5" style="display: flex;">Popup Modals</h1>-->

      <!-- page size  -->
      <div class="mt-3 rounded-3 bg-white p-3 shadow">
        <b-row>
          <b-col class="my-2 col-4 p-1" lg="3" md="4">
            <b-form-group class="mb-0 ms-2">
              <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" class="col-md-4" size="sm"
                             @change="handlePageSizeChange"></b-form-select>
            </b-form-group>
          </b-col>
          <!--        search        -->
          <b-col class="my-2 col-4" lg="6" md="4"></b-col>
          <!--          <b-col class="my-2 col-4 p-1" lg="3" md="4">-->
          <!--            <div class="d-flex flex-row align-items-center">-->
          <!--              <b-input-group class="me-2" size="sm">-->
          <!--                <b-form-input id="filter-input" v-model="filter" placeholder="Type to Search"-->
          <!--                              type="search"></b-form-input>-->
          <!--              </b-input-group>-->
          <!--              <button class="rounded btn-info me-4" @click="onFiltered">Search</button>-->
          <!--            </div>-->
          <!--          </b-col>-->
        </b-row>
        <b-table :busy="loading" :fields="fields" :items="allPollData" bordered hover striped>
          <template #cell(insert_date)="row">
            <div v-if="row.item.insert_date">
              {{ format_date_ddmmmyyyy(row.item.insert_date) }}
            </div>
          </template>
          <template #cell(active_yn)="row">
            <div v-if="row.item.active_yn === 'Y'" class="badge bg-success">
              Active
            </div>
            <div v-else class="badge bg-danger">
              Inactive
            </div>
          </template>
          <template #cell(enable_yn)="row">
            <div v-if="row.item.enable_yn === 'Y'" class="badge bg-success">
              Show
            </div>
            <div v-else class="badge bg-danger">
              Don't Show
            </div>
          </template>

          <template #cell(show_percentage_yn)="row">
            <div v-if="row.item.show_percentage_yn === 'Y'" class="badge bg-success">
              Yes
            </div>
            <div v-else class="badge bg-danger">
              No
            </div>
          </template>
          <template #cell(actions)="row">
            <div class="d-flex gap-1 justify-content-center">
              <router-link :to="{ name: 'EditPoll', params: {pollId: row.item.poll_id}}"
                           class="btn btn-info btn-sm"
                           type="button">
                <i class="fa-regular fa-pen-to-square"></i>
              </router-link>
              <button
                  class="btn btn-danger btn-sm delete-button" @click="deletePopup(row.item.poll_id)"><span
                  class="fa-solid fa-trash"></span></button>
            </div>
          </template>
          <template #table-busy>
            <div class="text-center text-danger my-2 px-2">
              <b-spinner class="align-middle mx-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
        <!--    Pagination            -->
        <b-row>
          <b-col class="mt-2" md="12" sm="12">
            <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" align="center" class="my-0"
                          next-text="Next" prev-text="Prev" @click="handlePageChange"></b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import Config from '@/config';
import {notify} from "@kyvg/vue3-notification";
import pollService from "@/services/poll.service";
import {format_date_ddmmmyyyy} from "../../helpers";

export default {
  name: 'AllPolls',
  components: {},
  mounted() {
    this.imageBasePath = Config.apiFileBasePath;
    this.getPollData();
  },
  created() {
    this.permissions = JSON.parse(localStorage.getItem("permissions"));
  },
  data() {
    return {
      permissions: {},
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'All Polls',
          to: '#'
        }
      ],
      imageBasePath: null,
      loading: false,
      allPollData: [],
      fields: [
        {
          label: 'Question', key: 'question', sortable: true, thStyle: {width: "40%"},
          tdClass: "px-3", thClass: "px-3",
        },
        {
          label: 'Status', key: 'active_yn', sortable: true, class: 'text-center',
          thStyle: {width: "10%"}, tdClass: "px-3", thClass: "px-3",
        },
        {key: 'enable_yn', label: 'Show Result', class: 'text-center', thStyle: {width: "10%"},},
        {key: 'show_percentage_yn', label: 'Immediate Result', class: 'text-center', thStyle: {width: "12%"},},
        {key: 'insert_date', label: 'Publish Date', class: 'text-center', thStyle: {width: "18%"},},
        {key: 'actions', label: 'Actions', class: 'text-center', thStyle: {width: "10%"},},
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [1, 5, 10, 100],
      filter: '',
      backupPopupData: [],
    }
  },
  methods: {
    format_date_ddmmmyyyy,
    handlePageSizeChange(value) {
      this.perPage = value;
      this.currentPage = 1;
      this.getPollData();
    },
    async handlePageChange() {
      await this.getPollData();
    },
    searchFormatter(data) {
      this.filter = data;
      if (this.filter != null && this.filter !== "") {
        this.allPollData = [];
        this.backupPopupData.forEach(item => {
          if (item.title.toLowerCase().includes(this.filter.toLowerCase())) {
            this.allPollData.push(item);
          }
        });
      } else {
        this.allPollData = this.backupPopupData;
      }
      this.totalRows = this.allPollData.length;
      this.currentPage = 1;
      return data;
    },
    async deletePopup(id) {
      try {
        const result = await this.$swal({
          title: 'Are you sure, You want to Delete this poll?',
          showCancelButton: true,
          cancelButtonText: 'No',
          cancelButtonColor: '#dd3333',
          showConfirmButton: true,
          confirmButtonText: 'Yes',
          confirmButtonColor: '#007bff',
        });
        if (result.isConfirmed) {
          this.loading = true;
          const response = await pollService.deletePoll(id);
          this.loading = false;
          if (response.data) {
            if (response.data.messageCode === 1) {
              notify({
                type: "success",
                title: "Delete Poll",
                text: response.data.message,
              });
              await this.getPollData();
            } else {
              notify({
                type: "error",
                title: "Error",
                text: response.data.message,
              });
            }
          }
        }
      } catch (error) {
        this.loading = false;
      }
    },
    async getPollData() {
      try {
        this.loading = true;
        var param = {
          pageNo: this.currentPage,
          pageSize: this.perPage,
        };
        const response = await pollService.getAllPollData(param);
        this.loading = false;
        if (response.data) {
          this.allPollData = response.data.data;
          this.backupPopupData = this.allPollData;
          this.totalRows = response.data.total;
        }
      } catch (error) {
        this.loading = false;
      }
    },

  }
}
</script>

<style scoped>

</style>
